import React from 'react';
import Select from 'react-select';

const customStyles = {
  menuPortal: (provided, state) => ({
    ...provided,
    zIndex: 99999,
  }),

}
export default class SelectSearch extends React.Component {
  render() {
    const options = this.props.options || [];
    const value = this.props.value || "";
    const disabled = this.props.disabled || false;
    const className = this.props.className || "";
    
    return (
      <Select
        value={value}
        onChange={(e) => this.props.onChange(e)}
        onInputChange={(e) => this.props.onInputChange?.(e)}
        options={options}
        isDisabled={disabled}
        isSearchable
        // menuIsOpen={true}
        styles={customStyles}
        isMulti={this.props.isMulti || false}
        menuPortalTarget={document.body}
        className={`customDropdown ${className}`}
      />
    );
  }
}

